



























import { Component, Vue } from 'vue-property-decorator'
import NewsModel from '@/_models/NewsModel'

@Component({
  components: {},
  computed: {},
})
export default class NewsList extends Vue {
  // computed
  get news(): NewsModel[] {
    return this.$store.state.news.all.items
  }

  get isLoading(): boolean {
    return this.$store.state.news.loading
  }

  get filteredData(): NewsModel[] {
    return !this.news ? [] : this.news
  }

  isInfo(type) {
    return type === 'info'
  }

  isImportant(type) {
    return type === 'important'
  }

  // After page created
  created() {
    this.$store.dispatch('news/getAll')
  }
}
